<template>
  <router-view />
</template>
<script>
  export default {
    name: 'LancamentoAvulsoModule',
  }
</script>
